import { BrandType } from "./Enums";

export class Account {
  id: number;
  company: string;
  country: string;
  brand: BrandType;
  fam: string;
  email: string;
  firstName: string;
  lastName: string;
  requestDate: Date;
  phoneNumber: string;
  address: string;
  comments: string;
  referenceId: string;
  userId: number; // in case user already created
  pending?: boolean;
}
